import {LitElement} from 'lit';
import {customElement, property} from 'lit/decorators.js';
import {inputStyles} from "@/components/input/input.styles.ts";
import {RequiredValidator, Validator} from "@/components/validators/validators.ts";
import {AutocompleteMixin, SuggestItem} from "@/components/autocomplete/autocomplete-mixin.ts";
import {autocompleteStyles} from "@/components/autocomplete/autocomplete.styles.ts";
import {labelStyles} from "@/components/label/label.styles.ts";



@customElement('sbk-autocomplete-input-city')
export class SbkAutocompleteInputCity extends AutocompleteMixin(LitElement) {

  @property({attribute: 'zip-input-value'})
  zipInputValue: string = ''

  selectOnlyOption = true;

  validatorMapper: {
    [key: string]: Validator
  } = {
    'required': RequiredValidator,
  }

  static get styles() {
    return [
      autocompleteStyles,
      labelStyles,
      inputStyles
    ];
  }

  async _querySuggestions(inputValue: string) {
    if (this.zipInputValue.length !== 5) {
      this.suggestions = [];
      this.close(true)
      return;
    }

    let urlParams;
    if (this.zipInputValue) {
      urlParams = new URLSearchParams({
        "zipCodeCity": this.zipInputValue,
        "city": inputValue.toLowerCase(),
      });
    } else {
      urlParams = new URLSearchParams({
        "zipOrCity": inputValue.toLowerCase(),
      });
    }
    await fetch('/ajax/middleware/searchAddress' + '?' + urlParams)
        .then((response) => {
          return response.text()
        })
        .then((data) => {
          const parsedSuggestions = JSON.parse(data);
          const allSuggestions: SuggestItem[] = [];
          Object.entries(parsedSuggestions).forEach((suggestion) => {
            allSuggestions.push( {
              label: <string> suggestion[1],
              value: <string> suggestion[1]
            } );
          });
          this.suggestions = allSuggestions;
        })
    await this.updateComplete;
  }
}